import { CheckCircle, Download, Send } from "lucide-react";
function FinalInvoice() {
  const invoice = {
    client: "Acme Corporation",
    invoiceNumber: "INV-2026-0312",
    serviceMonth: "March 2026",
    invoiceDate: "2026-03-06",
    status: "Approved"
  };
  const invoiceLines = [
    {
      id: 1,
      description: "Pallet Storage",
      quantity: 25,
      rate: 1.04,
      amount: 26
    },
    {
      id: 2,
      description: "Order Processing",
      quantity: 800,
      rate: 0.75,
      amount: 600
    },
    {
      id: 3,
      description: "Hosting Fee",
      quantity: null,
      rate: null,
      amount: 500
    },
    {
      id: 4,
      description: "Labor Hours - Warehouse",
      quantity: 13.5,
      rate: 45,
      amount: 607.5
    },
    {
      id: 5,
      description: "Outbound Shipping",
      quantity: 450,
      rate: 2.25,
      amount: 1012.5
    }
  ];
  const adjustments = [
    { id: 1, description: "Volume Discount - March", amount: -50 }
  ];
  const calculateSubtotal = () => {
    return invoiceLines.reduce((sum, line) => sum + line.amount, 0);
  };
  const calculateAdjustmentsTotal = () => {
    return adjustments.reduce((sum, adj) => sum + adj.amount, 0);
  };
  const calculateTotal = () => {
    return calculateSubtotal() + calculateAdjustmentsTotal();
  };
  const getStatusColor = (status) => {
    switch (status) {
      case "Approved":
        return "bg-blue-600 text-white";
      case "Sent":
        return "bg-blue-500 text-white";
      case "Paid":
        return "bg-blue-700 text-white";
      default:
        return "bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100";
    }
  };
  return <div className="p-8 max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Invoice Details</h1>
        <p className="text-gray-600 dark:text-gray-400">View final invoice summary</p>
      </div>

      {
    /* Invoice Header */
  }
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm p-8 mb-6">
        <div className="grid grid-cols-5 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Client
            </label>
            <div className="text-gray-900 dark:text-gray-100 font-medium">
              {invoice.client}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Invoice Number
            </label>
            <div className="text-gray-900 dark:text-gray-100 font-medium">
              {invoice.invoiceNumber}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Service Month
            </label>
            <div className="text-gray-900 dark:text-gray-100">
              {invoice.serviceMonth}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Invoice Date
            </label>
            <div className="text-gray-900 dark:text-gray-100">
              {invoice.invoiceDate}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Status
            </label>
            <div>
              <span className={`px-3 py-1 rounded text-sm font-medium ${getStatusColor(invoice.status)}`}>
                {invoice.status}
              </span>
            </div>
          </div>
        </div>
      </div>

      {
    /* Invoice Lines Table */
  }
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm mb-6">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Description
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Quantity
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Rate
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-800">
              {invoiceLines.map((line) => <tr key={line.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                  <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                    {line.description}
                  </td>
                  <td className="px-6 py-4 text-sm text-right text-gray-900 dark:text-gray-100">
                    {line.quantity !== null ? line.quantity : "-"}
                  </td>
                  <td className="px-6 py-4 text-sm text-right text-gray-900 dark:text-gray-100">
                    {line.rate !== null ? `$${line.rate.toFixed(2)}` : "-"}
                  </td>
                  <td className="px-6 py-4 text-sm text-right font-medium text-gray-900 dark:text-gray-100">
                    ${line.amount.toFixed(2)}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {
    /* Invoice Summary */
  }
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm p-6 mb-6">
        <div className="max-w-md ml-auto space-y-4">
          <div className="flex items-center justify-between pb-4 border-b border-gray-200 dark:border-gray-700">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Subtotal</span>
            <span className="text-lg font-medium text-gray-900 dark:text-gray-100">
              ${calculateSubtotal().toFixed(2)}
            </span>
          </div>

          {adjustments.length > 0 && <div className="space-y-2 pb-4 border-b border-gray-200 dark:border-gray-700">
              <div className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Adjustments</div>
              {adjustments.map((adj) => <div key={adj.id} className="flex items-center justify-between pl-4">
                  <span className="text-sm text-gray-600 dark:text-gray-400">{adj.description}</span>
                  <span className="text-sm font-medium text-gray-900 dark:text-gray-100">
                    ${adj.amount.toFixed(2)}
                  </span>
                </div>)}
            </div>}

          <div className="flex items-center justify-between pt-2">
            <span className="text-lg font-semibold text-gray-900 dark:text-gray-100">Total</span>
            <span className="text-2xl font-bold text-blue-600 dark:text-blue-400">
              ${calculateTotal().toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      {
    /* Action Buttons */
  }
      <div className="flex items-center gap-4">
        <button className="app-btn-gloss px-6 py-3">
          <CheckCircle className="w-5 h-5" />
          Approve Invoice
        </button>
        <button className="app-btn-gloss px-6 py-3">
          <Send className="w-5 h-5" />
          Export to Accounting
        </button>
        <button className="app-btn-gloss px-6 py-3">
          <Download className="w-5 h-5" />
          Download PDF
        </button>
      </div>
    </div>;
}
export {
  FinalInvoice
};
